import React from 'react';
import FormPage from '../../components/FormPage/FormPage';

const Gravacao: React.FC = () => (
  <FormPage
    seoTitle="Gravação do Webinar de DRE | 77Gestão"
    seoDescription="Receba a gravação da aula de DRE no seu e-mail."
    canonical="/webinar-dre/gravacao"
    noindex
    eyebrow="Webinar DRE"
    heading="Receba a gravação da aula"
    intro="Perdeu ao vivo ou quer rever? Deixe seus dados que enviamos o link da gravação no seu e-mail."
    fields={[
      { name: 'nome', label: 'Nome', required: true, placeholder: 'Seu nome' },
      { name: 'email', label: 'E-mail', type: 'email', required: true, placeholder: 'voce@empresa.com.br' },
    ]}
    subject="Pedido de gravação — Webinar DRE"
    submitLabel="Quero a gravação"
    successTitle="Gravação a caminho!"
    successText="Assim que disponibilizarmos, o link da gravação chega no e-mail que você informou."
  />
);

export default Gravacao;
